import { $getLocalStorage, $setLocalStorage } from '@/assets/common/common';
import { VueCookieNext } from 'vue-cookie-next';
import { createStore } from 'vuex';
import infoStore from './info';
import _merge from 'lodash/merge';
const store = _merge( infoStore, {
	state: {
		i18n: {}, // 语言
		langs: [
			{ value: 'zh-cn', label: '简体中文' },
			{ value: 'en-us', label: 'English' },
			// { value: 'ja-jp', label: '日本語' }
		],
		countryList: $getLocalStorage( 'countryList' ) || [], // 国家列表
		factoryObjList: $getLocalStorage( 'factoryObjs' ) || [], // 所属机构列表（所有状态）
		sysParams: $getLocalStorage( 'sysParamsNew' ) || [], // OEM信息
		uiColor: $getLocalStorage( 'uiColor' ) || {}, // OEM配色
		userInfo: $getLocalStorage( 'userInfo' ) || {}, // 用户信息
		permsList: $getLocalStorage( 'perms' ) || {}, // 用户权限点
		phoneAreaList: [], // 国家码列表
		global: {}, // ETCD配置（菜单、版本号等）
		isAside: true, // 侧边显示隐藏
		privacyPolicySwitch: false,
		termsOfUseSwitch: false,
		developerProtocol: false,
		applicationSpecification: false,
		factorySelect: $getLocalStorage( 'currentOrganization' ) || {},
		applyCancelOn: '',
		docAsideList: [],
		asideList: [],
		otherFactoryID: ''
	},
	mutations: {
		setAsideList( state, val ){
			state.asideList = val;
		},
		setApplyCancelOn( state, val ) {
			state.applyCancelOn = val;
		},
		setFactorySelect( state, val ) {
			$setLocalStorage( 'currentOrganization', val );
			state.factorySelect = val;
		},
		setPrivacyPolicy( state ) {
			state.privacyPolicySwitch = !state.privacyPolicySwitch;
		},
		setDockingAgreements( state ) {
			state.dockingAgreements = !state.dockingAgreements;
		},
		setDeveloperProtocol( state ) {
			state.developerProtocol = !state.developerProtocol;
		},
		setApplicationSpecification( state ) {
			state.applicationSpecification = !state.applicationSpecification;
		},
		setTermsOfUse( state ) {
			state.termsOfUseSwitch = !state.termsOfUseSwitch;
		},
		setOtherFactory( state, id ){
			state.otherFactoryID = id;
		},
		setI18n( state, val ) {
			state.i18n = val;
		},
		setCountry( state, val ) {
			// 为了确保登陆组件 所以存两次
			localStorage.setItem( 'countryList', JSON.stringify([...val]));
			$setLocalStorage( 'countryList', [...val]);
			state.countryList = val;
		},
		setPhone( state, val ) {
			$setLocalStorage( 'areaCodeOptions', JSON.stringify([...val]));
			state.phoneAreaList = val;
		},
		setFactoryObjs( state, val ) {
			// 获取当前选中机构
			let currentOrganization = val.find(( item ) => item.lastState === 'y' );
			// 判断选择机构不存在且为超管则直接赋值选择全部
			if ( !currentOrganization ) {
				if ( val[ 0 ].id !== 'new' ) {
					currentOrganization = val[ 0 ];
				} else {
					currentOrganization = {};
				}
			}
			// 选中机构存储
			this.commit( 'setFactorySelect', currentOrganization || {});
			$setLocalStorage( 'factoryObjs', val );
			state.factoryObjList = val;
		},
		setUserInfo( state, val ) {
			// 标题存储
			if ( val.nickName ) {
				VueCookieNext.setCookie( 'uTitle', val.nickName, {
					expire: '3d',
					path: '/',
				});
			}
			// 案例下载使用，后续全部接入新项目使用userInfo中的参数
			$setLocalStorage(
				'defaultDentalOrderReceive',
				val.defaultDentalOrderReceive || false
			);
			$setLocalStorage( 'userInfo', val );
			state.userInfo = val;
		},
		setPermsList( state, val ) {
			$setLocalStorage( 'perms', val );
			state.permsList = val;
		},
		setIsAside( state, val ) {
			state.isAside = val;
		},
		setGlobal( state, val ) {
			state.global = val;
		},
		setDocAsideList( state, val ) {
			state.docAsideList = val;
		},
	},
	actions: {},
	modules: {},
});
export default createStore( store );
